import { Color } from './../colors';
import { ScaleMode } from './../timeline';
import { Timeline, Milestone } from '../../components/Timeline';

const scaleMode: ScaleMode = 'month';
const screaming = false;
const shouldCompact = false;
const highlightWeekends = true;
const firstDate = new Date('Fri Jul 31 2020 00:34:31 GMT-0700 (Pacific Daylight Time)');
const totalDays = 80;

const bars = [
  {
    title: 'BUILD: Feature B',
    color: 'brilliantBlue' as Color,
    done: false,
    id: '1599206353859',
    startDate: new Date('2020-08-31T07:34:31.520Z'),
    endDate: new Date('2020-09-13T07:34:31.520Z'),
    description: 'Matt K',
  },
  {
    id: 'b',
    title: 'BUILD: Feature A',
    color: 'brilliantBlue' as Color,
    done: true,
    startDate: new Date('2020-08-17T07:34:31.520Z'),
    endDate: new Date('2020-08-30T07:34:31.520Z'),
    description: 'Nancy S',
  },
  {
    title: 'One-Off Task',
    color: 'purpleMist' as Color,
    done: false,
    id: '1599206404494',
    startDate: new Date('2020-09-07T07:34:31.520Z'),
    endDate: new Date('2020-09-13T07:34:31.520Z'),
    description: 'Lisa M',
  },
  {
    title: 'STABILIZE: Feature A',
    color: 'blueMoon' as Color,
    done: false,
    id: '1599206279062',
    startDate: new Date('2020-08-31T07:34:31.520Z'),
    endDate: new Date('2020-09-06T07:34:31.520Z'),
    description: '',
  },
  {
    title: 'DESIGN Feature B',
    color: 'midnightBlue' as Color,
    done: true,
    id: '1599206335037',
    startDate: new Date('2020-08-24T07:34:31.520Z'),
    endDate: new Date('2020-08-30T07:34:31.520Z'),
    description: '',
  },
  {
    title: 'OOO: Cameron',
    color: 'stoneGray' as Color,
    done: true,
    id: '1599206423308',
    startDate: new Date('2020-08-17T07:34:31.520Z'),
    endDate: new Date('2020-08-23T07:34:31.520Z'),
    description: '',
  },
  {
    title: 'OOO: Nancy',
    color: 'stoneGray' as Color,
    done: false,
    id: '1599206452849',
    startDate: new Date('2020-09-07T07:34:31.520Z'),
    endDate: new Date('2020-09-20T07:34:31.520Z'),
    description: '',
  },
  {
    title: 'STABILIZE: Feature B',
    color: 'blueMoon' as Color,
    done: false,
    id: '1599206366947',
    startDate: new Date('2020-09-14T07:34:31.520Z'),
    endDate: new Date('2020-09-20T07:34:31.520Z'),
    description: '',
  },
  {
    title: 'DESIGN: Feature A',
    color: 'midnightBlue' as Color,
    done: true,
    id: '1599205045861',
    startDate: new Date('2020-08-10T07:34:31.520Z'),
    endDate: new Date('2020-08-16T07:34:31.520Z'),
    description: 'Designer Jack',
  },
  {
    title: 'On-Call',
    color: 'blackInk' as Color,
    done: true,
    id: '1599205012941',
    startDate: new Date('2020-08-17T07:34:31.520Z'),
    endDate: new Date('2020-08-23T07:34:31.520Z'),
    description: 'Jenny J',
  },
  {
    title: 'On-Call',
    color: 'blackInk' as Color,
    done: true,
    id: '1599206269187',
    startDate: new Date('2020-08-10T07:34:31.520Z'),
    endDate: new Date('2020-08-16T07:34:31.520Z'),
    description: 'Lisa M',
  },
  {
    title: 'On-Call',
    color: 'blackInk' as Color,
    done: true,
    id: '1599204914213',
    startDate: new Date('2020-08-24T07:34:31.520Z'),
    endDate: new Date('2020-08-30T07:34:31.520Z'),
    description: 'John S',
  },
  {
    title: 'On-Call',
    color: 'blackInk' as Color,
    done: false,
    id: '1599204894718',
    startDate: new Date('2020-09-14T07:34:31.520Z'),
    endDate: new Date('2020-09-20T07:34:31.520Z'),
    description: 'Cameron C',
  },
  {
    title: 'On-Call',
    color: 'blackInk' as Color,
    done: false,
    id: '1599204979174',
    startDate: new Date('2020-09-21T07:34:31.520Z'),
    endDate: new Date('2020-09-27T07:34:31.520Z'),
    description: 'Lisa M',
  },
  {
    title: 'On-Call',
    color: 'blackInk' as Color,
    done: false,
    id: '1599204892833',
    startDate: new Date('2020-09-07T07:34:31.520Z'),
    endDate: new Date('2020-09-13T07:34:31.520Z'),
    description: 'Matt K',
  },
  {
    id: 'a',
    title: 'On-Call',
    color: 'blackInk' as Color,
    done: false,
    startDate: new Date('2020-08-31T07:34:31.520Z'),
    endDate: new Date('2020-09-06T07:34:31.520Z'),
    description: 'Nancy S',
  },
];

// const milestoneDate = addDays(today, 3);
const milestones: Milestone[] = [
  { id: 'Mon Sep 07 2020', title: 'Launch: Feature A', date: new Date('2020-09-07T07:00:00.000Z') },
];

const layout = [
  { w: 7, h: 1, x: 31, y: 0, i: 'a', minH: 1, maxH: 1, moved: false, static: false },
  { w: 14, h: 1, x: 17, y: 1, i: 'b', minH: 1, maxH: 1, moved: false, static: false },
  { w: 7, h: 1, x: 38, y: 0, i: '1599204892833', minH: 1, maxH: 1, moved: false, static: false },
  { w: 7, h: 1, x: 45, y: 0, i: '1599204894718', minH: 1, maxH: 1, moved: false, static: false },
  { w: 7, h: 1, x: 24, y: 0, i: '1599204914213', minH: 1, maxH: 1, moved: false, static: false },
  { w: 7, h: 1, x: 52, y: 0, i: '1599204979174', minH: 1, maxH: 1, moved: false, static: false },
  { w: 7, h: 1, x: 17, y: 0, i: '1599205012941', minH: 1, maxH: 1, moved: false, static: false },
  { w: 7, h: 1, x: 10, y: 1, i: '1599205045861', minH: 1, maxH: 1, moved: false, static: false },
  { w: 7, h: 1, x: 10, y: 0, i: '1599206269187', minH: 1, maxH: 1, moved: false, static: false },
  { w: 7, h: 1, x: 31, y: 1, i: '1599206279062', minH: 1, maxH: 1, moved: false, static: false },
  { w: 7, h: 1, x: 24, y: 2, i: '1599206335037', minH: 1, maxH: 1, moved: false, static: false },
  { w: 14, h: 1, x: 31, y: 2, i: '1599206353859', minH: 1, maxH: 1, moved: false, static: false },
  { w: 7, h: 1, x: 45, y: 2, i: '1599206366947', minH: 1, maxH: 1, moved: false, static: false },
  { w: 7, h: 1, x: 38, y: 1, i: '1599206404494', minH: 1, maxH: 1, moved: false, static: false },
  { w: 7, h: 1, x: 17, y: 3, i: '1599206423308', minH: 1, maxH: 1, moved: false, static: false },
  { w: 14, h: 1, x: 38, y: 3, i: '1599206452849', minH: 1, maxH: 1, moved: false, static: false },
];

const timeline: Timeline = {
  id: 'team',
  title: 'Team Sprint',
  bars,
  layout,
  milestones,
  highlightWeekends,
  shouldCompact,
  firstDate,
  totalDays,
  screaming,
  scaleMode,
  initialAnchorDate: new Date('2020-09-07T07:34:31.520Z'),
};

export default timeline;
